var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"picker-item flex justify-center items-center",class:{ active: _vm.active }},_vm.$listeners),[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }